import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload
  },
  setup: function setup() {
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var activityId = route.query.activityId; // 提交按钮文字

    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit; // 详情回显
    // 详情回显

    var detail = reactive({
      detailContent: {
        activity: {
          nums: ''
        }
      }
    });

    function getDetail() {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getVoteDetail"](activityId);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                detail.detailContent = _objectSpread({}, data);
                console.log(detail.detailContent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    var list = reactive({
      rank: [{}]
    });

    function getRank() {
      return _getRank.apply(this, arguments);
    }

    function _getRank() {
      _getRank = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getVoteRank"](activityId);

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                list.rank = data;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getRank.apply(this, arguments);
    }

    onMounted(function () {
      // 详情
      getRank();
      getDetail();
    });
    return {
      submitText: submitText,
      list: list,
      detail: detail
    };
  }
});